import React from 'react';

import Loader from '../../components/Loader';

// Renders the standard loading / error / empty / content states for a data section,
// so components don't each re-implement the same guard branches (and inner
// `renderBody` helpers). Pairs with the useHttpData hook's { isReady, error }.
//
//   <AsyncSection isReady={isReady} error={error} isEmpty={rows.length === 0}
//                 errorText="Could not load." emptyText="Nothing here.">
//       {content}
//   </AsyncSection>
//
// `variant`: "card" (default) uses the boxed .gateways-overview__message style;
// "inline" uses the lighter .gateway-section__empty paragraph style.
const AsyncSection = ({
    isReady,
    error,
    isEmpty = false,
    errorText = 'Could not load data.',
    emptyText = 'No data.',
    variant = 'card',
    children,
}) => {
    if (!isReady) {
        return <Loader />;
    }
    if (error || isEmpty) {
        const text = error ? errorText : emptyText;
        if (variant === 'inline') {
            return <p className="gateway-section__empty">{text}</p>;
        }
        return <div className={`gateways-overview__message${error ? ' gateways-overview__message--error' : ''}`}>{text}</div>;
    }
    return children;
};

export default AsyncSection;
